import Vue from 'vue'
import store from '@/store/index.js'
import _ from 'lodash'


const academicYear = {
  from: '',
  to: ''
}
export default class AgendaService {



  addDays(baseDate, days) {
    //  let date = new Date(baseDate)
    //  return new Date(date.getTime() - (date.getTimezoneOffset() * 60000) + days * 24 * 60 * 60 * 1000)
    //  return new Date(new Date(this.dateObjectToDateString(baseDate)).getTime() + days * 24 * 60 * 60 * 1000)

    let res = new Date(this.dateObjectToDateString(baseDate))
    let originalDate = res.getDate()
    res.setTime(res.getTime() + days * 86400000)
    if (res.getDate() === originalDate) { // if it still the same date -> 1 more hour
      res.setTime(res.getTime() + 1 * 60 * 60 * 1000)
      if (res.getDate() === originalDate) { // if it still the same date -> 1 more hour
        res.setTime(res.getTime() + 1 * 60 * 60 * 1000)
        return res
      }
      return res
    }
    return res
    //  return new Date(new Date(baseDate).getTime() + days * 24 * 60 * 60 * 1000)
  }
  getInitialRangeMin() {
    return this.getTodayAsDateString()
  }
  getInitialRangeMax() {
    return this.dateObjectToDateString(this.addMonths(new Date(this.getTodayAsDateString()), 1))
  }
  removeDays(baseDate, days) {
    let res = new Date(baseDate)
    res.setTime(res.getTime() - days * 86400000)
    return res
    //  return new Date(new Date(baseDate).getTime() - days * 24 * 60 * 60 * 1000)
    //  return new Date(new Date(baseDate).getTime() - days * 24 * 60 * 60 * 1000)
  }
  addMonths(baseDate, months) {
    return this.addDays(baseDate, 30 * months)
  }
  removeMonths(baseDate, months) {
    return this.removeDays(baseDate, 30 * months)
  }
  isBefore(first, second) {
    return new Date(first) < new Date(second)
  }
  isAfter(first, second) {
    return new Date(first) > new Date(second)
  }
  isBetween(dt, from, to) {
    return this.isAfter(dt, from) && this.isBefore(dt, to)
  }
  isEqual(dt1, dt2) {
    return new Date(dt1).getTime() === new Date(dt2).getTime()
  }
  isOnSameDay(dt1, dt2) {
    return this.dateObjectToDateString(new Date(dt1)) === this.dateObjectToDateString(new Date(dt2))
  }
  getAcademicYear() {
    return academicYear
  }
  isBeforeAcademicYear(aDate) {
    return this.isBefore(aDate, academicYear.from)
  }
  isAfterAcademicYear(aDate) {
    return this.isAfter(aDate, academicYear.to)
  }
  isOnBeginRangeOfAcademicYear(aDate) {
    if (academicYear.from === '') {
      this.initializeSchooljaar()
    }
    return this.isOnSameDay(aDate, academicYear.from)
  }
  isOnEndRangeOfAcademicYear(aDate) {
    if (academicYear.to === '') {
      this.initializeSchooljaar()
    }
    return this.isOnSameDay(aDate, academicYear.to)
  }
  initializeSchooljaar() {
    let curr = new Date()
    let currSeptember = new Date(curr.getFullYear(), 8, 1)
    let pastSeptember = new Date(curr.getFullYear() - 1, 8, 1)
    let nextSeptember = new Date(curr.getFullYear() + 1, 8, 1)
    if (this.isBetween(curr, currSeptember, nextSeptember)) {
      academicYear.from = currSeptember
      academicYear.to = new Date(curr.getFullYear() + 1, 7, 31)
    } else if (this.isBetween(curr, pastSeptember, currSeptember)) {
      academicYear.from = pastSeptember
      academicYear.to = new Date(curr.getFullYear(), 7, 31)
    }
  }

  getDateWithZeroHour(dateObject) {
    //  return new Date()
    let res = new Date(dateObject)
    res.setHours(0)
    res.setMinutes(0)
    res.setSeconds(0)
    res.setMilliseconds(0)
    return res
  }

  daterangepickerSettings() {
    return {
      'singleDatePicker': true,
      'showDropdowns': true,
      'autoApply': true,
      'timePicker24Hour': true,
      'timePickerIncrement': 5,
      'dateLimit': {
        'days': 7
      },
      'locale': {
        'format': 'YYYY-MM-DD',
        'separator': ' - ',
        'applyLabel': 'Apply',
        'cancelLabel': 'Cancel',
        'fromLabel': 'From',
        'toLabel': 'To',
        'customRangeLabel': 'Custom',
        'weekLabel': 'W',
        'daysOfWeek': [
          'Zo',
          'Ma',
          'Di',
          'Wo',
          'Do',
          'Vr',
          'Za'
        ],
        'monthNames': [
          'Januari',
          'Februari',
          'Maart',
          'April',
          'Mei',
          'Juni',
          'Juli',
          'Augustus',
          'September',
          'Oktober',
          'November',
          'December'
        ],
        'firstDay': 1
      },
      'minDate': '2016-01-01',
      'maxDate': '2017-10-10',
      'opens': 'left'
    }
  }

  initializeCalendar(element, dateToBeInitialized, cbFunction, hoursVisible = false) {
    let drpSettings = this.daterangepickerSettings()
    /* global $ */
    dateToBeInitialized = new Date(this.dateObjectToDateString(dateToBeInitialized))
    if (hoursVisible) {
      drpSettings.locale.format = 'YYYY-MM-DD h:mm'
      drpSettings.timePicker = true
      drpSettings.startDate = this.dateObjectToDateString(dateToBeInitialized) + ' ' + dateToBeInitialized.getHours() + ':' + dateToBeInitialized
        .getMinutes()
      drpSettings.endDate = this.dateObjectToDateString(dateToBeInitialized) + ' ' + dateToBeInitialized.getHours() + ':' + dateToBeInitialized
        .getMinutes()
    } else {
      drpSettings.startDate = this.dateObjectToDateString(dateToBeInitialized)
      drpSettings.endDate = this.dateObjectToDateString(dateToBeInitialized)
    }
    drpSettings.minDate = academicYear.from
    drpSettings.maxDate = academicYear.to
    //  this.daterangepickerSettings.isInvalidDate = function (a) {
    //    console.log(a)
    //    console.log($('.fa.famenubar.fa-calendar').data('daterangepicker').startDate)
    //    return a.isSame($('.fa.famenubar.fa-calendar').data('daterangepicker').startDate)
    //  }
    setTimeout(() => {
      $(element).daterangepicker(drpSettings, cbFunction)
    }, 300)
  }

  objectIsEmpty(daysObject) {
    let counter = 0
    for (var property in this.days) {
      if (this.days.hasOwnProperty(property)) {
        counter += 1
      }
    }
    return counter === 0
  }

  getDutchShortDateString(dateObject) { //needed
    let day = dateObject.getDay()
    if (day === 1) {
      return 'Ma'
    }
    if (day === 2) {
      return 'Di'
    }
    if (day === 3) {
      return 'Wo'
    }
    if (day === 4) {
      return 'Do'
    }
    if (day === 5) {
      return 'Vr'
    }
    if (day === 6) {
      return 'Za'
    }
    if (day === 0) {
      return 'Zo'
    }
  }
  addZeroIfNeeded(str) {
    if (str.length === 1) {
      return '0' + str
    }
    return str
  }
  getFormattedMonth(dateObject) { //needed *
    let month = new Date(dateObject).getMonth() + 1
    return this.addZeroIfNeeded(month + '')
  }
  getFormattedDay(dateObject) { //needed *
    return this.addZeroIfNeeded(dateObject.getDate() + '')
  }
  getiOSFriendlyDateString(date) {
    //  if (dateString instanceof Date) {
    //    return this.dateObjectToDateString(dateString)
    //  }
    //  return dateString.split(' ').join('T').split('-').join('/')
    if (date instanceof Date) {
      return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toJSON().split('T').join(' ').split('-').join('/')
    }
    date = new Date(date.split('T').join(' ').split('-').join('/'))
    return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toJSON().split('T').join(' ').split('-').join('/')
  }
  formatDateToShortDateDisplayType(dateString, p) { // needed*
    let dt = this.initDateObjectFromServerDateFormat(dateString)
    let res = this.getDutchShortDateString(dt)
    return res + ' ' + this.getFormattedDay(dt) + '/' + this.getFormattedMonth(dt)
  }
  formatDateDayMonthYearDisplay(dateString, p) { // needed*
    let dt = this.initDateObjectFromServerDateFormat(dateString)
    let res = this.getDutchShortDateString(dt)
    return res + ' ' + this.getFormattedDay(dt) + '/' + this.getFormattedMonth(dt) + '/' + dt.getFullYear()
  }
  formatDateToTimeDisplayType(dateString) {
    let dt = this.initDateObjectFromServerDateFormat(dateString)
    return this.addZeroIfNeeded(dt.getHours() + '') + ':' + this.addZeroIfNeeded(dt.getMinutes() + '') + ' u'
  }
  formatDateToAscendingDisplayType(dateString) {
    let dt = this.initDateObjectFromServerDateFormat(dateString)
    return this.getFormattedDay(dt) + '-' + this.getFormattedMonth(dt) + '-' + dt.getFullYear()
  }
  formatDateToDescendingDisplayType(dateString) {
    let dt = this.initDateObjectFromServerDateFormat(dateString)
    return dt.getFullYear() + '-' + this.getFormattedMonth(dt) + '-' + this.getFormattedDay(dt)
  }
  formatDateToLongDateDisplayType(dateString) {
    return this.formatDateToDescendingDisplayType(dateString) + ' ' + this.formatDateToTimeDisplayType(dateString)
  }
  formatDateToPostToServer(dateObject) {
    return new Date(dateObject.getTime() - (dateObject.getTimezoneOffset() * 60000)).toJSON().split('T').join(' ').split('.')[0].split('-').join(
      '/')
  }
  /* addHoursToGeldigVanOfAgendaPunt (ap) {
     if (typeof ap.GeldigVan === 'string' && ap.GeldigVan.length > 0) {
       let dateObject = new Date(ap.GeldigVan)
       dateObject.setHours(dateObject.getHours() + 2)
       ap.GeldigVan = this.formatDateToPostToServer(dateObject)
       return ap
     }
     return ap
   } */
  allDaysLoadedWithinRange() {
    let loadedDays = store.state.wAgenda.days
    let min = store.state.wAgenda.rangeMin
    let minDateString = this.dateObjectToDateString(store.state.wAgenda.rangeMin)
    let maxDateString = this.dateObjectToDateString(store.state.wAgenda.rangeMax)
    while (minDateString !== maxDateString) {
      if (typeof loadedDays[minDateString] === 'undefined') {
        return false
      }
      min = this.addDays(min, 1)
      minDateString = this.dateObjectToDateString(min)
    }
    if (typeof loadedDays[maxDateString] === 'undefined') {
      return false
    }
    return true
  }
  createDaysForRange(min, max, moduleName, propName = 'days', forceReload) {
    var loadedDays = {}
    if (!forceReload) {
      loadedDays = store.state[moduleName][propName]
    }
    let result = {}
    let minDateString = this.dateObjectToDateString(min)
    let maxDateString = this.dateObjectToDateString(max)
    while (minDateString !== maxDateString) {
      if ((propName === 'daysOnTheFly' || loadedDays === undefined || typeof loadedDays[minDateString] === 'undefined') &&
        (!this.isBefore(min, this.getAcademicYear().from) && !this.isAfter(min, this.getAcademicYear().to))) {
        result[minDateString] = {}
      }
      min = this.addDays(min, 1)
      minDateString = this.dateObjectToDateString(min)
    }
    if (loadedDays === undefined || typeof loadedDays[maxDateString] === 'undefined') {
      result[maxDateString] = {}
    }
    //  console.log(result)
    return result
  }

  createDaysForAgendaPunten(agendaPunten) {
    let toBeAddedDays = {}
    for (let i = 0; i < agendaPunten.length; i++) {
      let dayString = this.dateObjectToDateString(agendaPunten[i].Van)
      if (typeof toBeAddedDays[dayString] === 'undefined') {
        toBeAddedDays[dayString] = {}
      }
    }
    return toBeAddedDays
  }

  isTypePuntAllowed(typePunt) {
    return typePunt === 'LESSENROOSTER' || typePunt === 'TOETS' || typePunt === 'TAAK' ||
      typePunt === 'AANDACHTSPUNT' || typePunt === 'ACTIVITEIT' || typePunt === 'LEERKRACHT' || typePunt === 'UURSCHEMA'
  }

  capitalizeFirstLetters(string) {
    let res = ''
    let splittedWords = string.split(' ')
    for (let i = 0; i < splittedWords.length; i++) {
      res += splittedWords[i].charAt(0).toUpperCase() + splittedWords[i].slice(1).toLowerCase() + ' '
    }
    return res.substr(0, res.length - 1)
  }

  existsInAllIdsOfAgendaPunt(id) {
    id = parseInt(id)
    let allIDs = store.state.wAgenda.allIdsOfAgendaPunts
    for (let i = 0; i < allIDs.length; i++) {
      if (allIDs[i] === id) {
        return true
      }
    }
    return false
  }

  capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
  }

  getTimePeriodOfAgendaPunt(agendaPunt) {
    return agendaPunt.Van.split(' ')[1].substr(0, 5) + '_' + agendaPunt.Tot.split(' ')[1].substr(0, 5)
  }

  getTimePeriodOfReservatieDatum(agendaPunt) {
    if (agendaPunt.Reservatievan.indexOf('T') !== -1) {
      return agendaPunt.Reservatievan.split('+')[0].split('T')[1].substr(0, 5) + '_' + agendaPunt.Reservatietot.split('+')[0].split('T')[1].substr(
        0, 5)
    }
    return agendaPunt.Reservatievan.split(' ')[1].substr(0, 5) + '_' + agendaPunt.Reservatietot.split(' ')[1].substr(0, 5)
  }

  getDayOfAgendaPunt(agendaPunt) {
    return agendaPunt.Van.split(' ')[0].split('-').join('/')
  }

  getDayOfReservatieDatum(reservatie) {
    if (reservatie.Reservatievan.indexOf('T') !== -1) {
      return reservatie.Reservatievan.split('T')[0].split('-').join('/')
    }
    return reservatie.Reservatievan.split(' ')[0].split('-').join('/')
  }

  getVanDayOfAgendaPunt(agendaPunt) {
    return this.getDayOfAgendaPunt(agendaPunt)
  }

  getTotDayOfAgendaPunt(agendaPunt) {
    return agendaPunt.Tot.split(' ')[0].split('-').join('/')
  }







  mergeComplementaryTaskList(newTaskLists) {
    let self = this
    let complementaryTaskList = JSON.parse(JSON.stringify(store.state.wAgenda.complementaryTaskList))
    newTaskLists.push.apply(newTaskLists, complementaryTaskList)
    newTaskLists.map(function (c) {
      c = self.addComplementaryProperties(c)
    })
    return _.uniqBy(newTaskLists, 'ID')
  }

  getCopyOfObject(obj) {
    return typeof obj === 'object' ? JSON.parse(JSON.stringify(obj)) : obj
  }

  extendHolidays(holidays) {
    let toBeAddedHolidayObjects = []
    let self = this

    function addToBeAddedHolidayObject(holidayObject) {
      let toBeAddedHolidayObject = self.getCopyOfObject(holidayObject)
      toBeAddedHolidayObject.Tot = self.getVanDayOfAgendaPunt(toBeAddedHolidayObject) + ' 23:59:59'
      toBeAddedHolidayObjects.push(toBeAddedHolidayObject)
    }
    for (let i = 0; i < holidays.length; i++) {
      holidays[i].Van = holidays[i].Van.split('-').join('/')
      holidays[i].Tot = holidays[i].Tot.split('-').join('/')
      let vanDate = this.getVanDayOfAgendaPunt(holidays[i])
      let totDate = this.getTotDayOfAgendaPunt(holidays[i])
      if (vanDate !== totDate) {
        while (vanDate !== totDate) {
          addToBeAddedHolidayObject(holidays[i])
          holidays[i].Van = this.dateObjectToDateString(this.addDays(holidays[i].Van, 1)) + ' 00:00:00'
          vanDate = this.getVanDayOfAgendaPunt(holidays[i])
        }
        addToBeAddedHolidayObject(holidays[i])
      } else {
        addToBeAddedHolidayObject(holidays[i])
      }
    }
    return toBeAddedHolidayObjects
  }





  arrayPropsToStringArray(arr, prop) {
    let res = ''
    for (var i = 0; i < arr.length; i++) {
      res = res + arr[i][prop] + ','
    }
    res = res.slice(0, -1)
    return res
  }

  getTodayAsDateString() {
    let today = new Date()
    today.setHours(0)
    today.setMinutes(0)
    today.setSeconds(0)
    today.setMilliseconds(0)
    return this.dateObjectToDateString(today)
  }

  initDateObjectFromServerDateFormat(str) { // needed*
    if (str instanceof Date) {
      return str
    }
    return new Date(str.split('-').join('/'))
  }

  dateObjectToDateString(date) {
    date = new Date(typeof date === 'string' ? date.split('T').join(' ').split(' ')[0].split('-').join('/') : date)
    return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toJSON().split('T').join(' ').split(' ')[0].split('-').join('/')
    //  return date.toISOString().split('T')[0]
  }

  isString(str) {
    return typeof str === 'string'
  }
  isTitel(titel) {
    if (!this.isString(titel)) {
      return [false, 'Naam connectie is niet ingevuld']
    }
    if (titel.length === 0) {
      return [false, 'Titel mag niet leeg zijn']
    }
    if (titel.length > 150) {
      return [false, 'Titel mag niet langer zijn dan 150 karakters']
    }
    return [true, '']
  }

  isComment(str, CommentType) {
    if (str.length > 150) {
      return [false, CommentType + ' mag niet langer zijn dan 150 karakters']
    }
    return [true, '']
  }

  isDetails(details) {
    return this.isComment(details, 'Details')
  }

  isNota(nota) {
    return this.isComment(nota, 'Nota')
  }

  isOmschrijving(omschrijving) {
    return this.isComment(omschrijving, 'Omschrijving')
  }

  isMeegedeeldOp(meegedeeldOp, vanDatum) {
    meegedeeldOp = typeof meegedeeldOp === 'string' ? meegedeeldOp.split('T').join(' ').split(' ')[0].split('-').join('/') : meegedeeldOp
    vanDatum = typeof vanDatum === 'string' ? vanDatum.split('T').join(' ').split(' ')[0].split('-').join('/') : vanDatum
    console.log(meegedeeldOp)
    console.log(vanDatum)
    return [this.isBefore(meegedeeldOp, vanDatum), 'Gekozen datum moet vóór het lesmoment liggen']
  }
}
